import { render } from "./ImportIniciativa.vue?vue&type=template&id=5a21918c"
import script from "./ImportIniciativa.vue?vue&type=script&lang=js"
export * from "./ImportIniciativa.vue?vue&type=script&lang=js"

import "./ImportIniciativa.vue?vue&type=style&index=0&id=5a21918c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__